import * as Yup from 'yup';

/** @constant {ObjectShape} - Yup Object used for validationScheme in Review Packet CM9 procedure */
const CM9Scheme = Yup.object().shape({
    CM9code: Yup.string()
        .min(8, 'Storage must be 8 characters at minimum!')
        .max(15, 'Storage must be 15 characters at maximum!')
        .required('Storage is required'),
});
export { CM9Scheme };
